<template>
    <v-dialog
        v-model="showDialog"
        max-width="500"
    >
        <v-card v-if="booking">

            <v-card-title class="align-start flex-column"
                          :style="{'background-color': $root.siteconfig.appbar.props.backgroundColor, color: $root.siteconfig.appbar.props.color }">
                <div class="fill-width font-weight-bold ml-3">
                    <span>{{serviceName}}</span>
                    <v-btn icon @click="showDialog = false" class="float-right mr-2"><v-icon :style="{'background-color': $root.siteconfig.appbar.props.backgroundColor, color: $root.siteconfig.appbar.props.color }">mdi-close</v-icon></v-btn>
                </div>
            </v-card-title>

            <v-card-text>
                <div class="zoezi-checkout-summary-resource-booking ma-2">
                    <div class="zoezi-checkout-summary-resource-booking-resource d-flex">
                        <div class="justify-end">
                            <v-avatar size="60">
                                <!--_FIXME: zoezi-user-avatar  -->
                                <v-auto-img class="zoezi-staff-image" :src="staffimagekey" />
                            </v-avatar>
                        </div>
                        <span class="ml-3 d-flex flex-column align-start justify-center">
                            <div class="text-uppercase">Utövare</div>
                            <div class="zoezi-resource-name font-weight-bold">{{resourceNames}}</div>
                        </span>
                    </div>

                    <div class="zoezi-checkout-summary-resource-booking-details pt-4" style="margin-left: 72px">
                        <div class="mb-2"><v-icon small color="black" class="mr-3">mdi-calendar-month-outline</v-icon>{{Date.newFull(bookingTime).hhmm()}} - {{bookingEndTime.hhmm()}}, {{Date.formatFullShort(bookingTime)}}</div>
                        <div class="mb-2"><v-icon small color="black" class="mr-3">mdi-clock-outline</v-icon>{{bookingDuration}} min</div>
                        <div class="mb-2" v-if="showPrice"><v-icon small color="black" class="mr-3">mdi-ticket-outline</v-icon>{{bookingPrice | price}}</div>

                        <template v-if="allResources.length > 1">
                            <div v-for="resource in allResources" :key="resource.id" class="mb-2">
                                <div>
                                    <v-avatar class="mr-2" :size="32">
                                        <v-auto-img :src="$api.getImageUrl(resource.imagekey, 100)" />
                                    </v-avatar>
                                    {{resource.lastname}} ({{resource.slots.map(s => s.start.hhmm() + '-' + s.end.hhmm()).join(', ')}})
                                </div>
                                <div v-for="optional in resource.optionalResources" :key="optional.id" class="mt-1" style="margin-left: 40px">
                                    <v-avatar class="mr-2" :size="24">
                                        <v-auto-img :src="optional.imagekey" />
                                    </v-avatar>
                                    {{optional.lastname}}
                                </div>
                            </div>
                        </template>

                        <template v-else>
                            <div v-for="resource in sortedOptionalResources" :key="resource.id" class="mb-2">
                                <v-avatar class="mr-2" :size="32">
                                    <v-auto-img :src="resource.imagekey" />
                                </v-avatar>
                                {{resource.lastname}}
                            </div>
                        </template>

                        <div v-if="contactInfo" class="d-flex"><v-icon small color="black" class="align-start mr-3 mt-1">mdi-map-marker-outline</v-icon>
                            <span>
                                <div>{{contactInfo.address}}</div>
                                <div>{{contactInfo.zipCode}} {{contactInfo.city}}</div>
                            </span>
                        </div>

                        <div v-if="extendedInfoEntries.length || (canEditExtendedInfo && serviceExtendedInfo.length)" class="mt-3">
                            <div class="d-flex align-center mb-2">
                                <div class="font-weight-bold">{{$translate('Questions')}}</div>
                                <v-spacer />
                                <v-btn v-if="canEditExtendedInfo && serviceExtendedInfo.length && !editing" icon small @click="startEditingExtendedInfo()" :aria-label="$translate('Edit')">
                                    <v-icon small>mdi-pencil</v-icon>
                                </v-btn>
                            </div>
                            <template v-if="!editing">
                                <div v-for="entry in extendedInfoEntries" :key="entry.question" class="mb-1">
                                    <span class="font-italic font-weight-bold">{{entry.question}}</span> - {{entry.answer}}
                                </div>
                            </template>
                            <v-form v-else ref="extendedInfoForm" v-model="extendedInfoValid" @submit.prevent="saveExtendedInfo()">
                                <form-field v-for="field in editFields" :key="field.name" :field="field" star v-model="field.value" dense />
                                <div class="d-flex justify-end mt-2">
                                    <v-btn text small @click="cancelEditingExtendedInfo()" :disabled="savingExtendedInfo">{{$translate('Cancel')}}</v-btn>
                                    <v-btn text small color="primary" @click="saveExtendedInfo()" :loading="savingExtendedInfo" :disabled="!extendedInfoValid">{{$translate('Save')}}</v-btn>
                                </div>
                            </v-form>
                        </div>
                    </div>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-btn block @click="cancelBooking()" text color="error" :loading="loading" v-if="resourceBooking.unbookable">{{$translate('CANCEL_BOOKING')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'zoezi-resourcebooking-dialog',
    props: ['value', 'booking'],

    watch: {
        value: {
            immediate: true,
            handler(value) {
                this.showDialog = value;
            }
        },
        showDialog(value) {
            this.$emit('input', value);
            if (!value) {
                this.editing = false;
                this.editFields = [];
                this.extendedInfoValid = true;
                this.savingExtendedInfo = false;
            }
        },
        booking() {
            this.editing = false;
            this.editFields = [];
            this.extendedInfoValid = true;
            this.savingExtendedInfo = false;
        }
    },
    data: () => ({
        showDialog : false,
        loading: false,
        editing: false,
        editFields: [],
        extendedInfoValid: true,
        savingExtendedInfo: false
    }),

    computed: {
        // Normalize booking structure - data can exist directly on booking or nested in booking.rb
        resourceBooking() {
            return this.booking.rb || this.booking;
        },
        serviceName() {
            return this.booking.text || this.resourceBooking.servicename;
        },
        resourceNames() {
            // Show all resources from siblings if available
            if (this.booking.siblings && this.booking.siblings.length > 1) {
                const uniqueNames = [...new Set(this.booking.siblings.map(rb => rb.staffname).filter(Boolean))];
                return uniqueNames.join(', ');
            }
            return this.resourceBooking.staffname;
        },
        allResources() {
            // Get all resources from siblings with their booked time slots and the
            // optional resources chosen for each, so the customer can see which optional
            // resource belongs to which room/time.
            if (this.booking.siblings && this.booking.siblings.length > 1) {
                const resourceMap = new Map();
                this.booking.siblings.forEach(rb => {
                    if (rb.staffname) {
                        if (!resourceMap.has(rb.staff_id)) {
                            resourceMap.set(rb.staff_id, {
                                id: rb.staff_id,
                                lastname: rb.staffname,
                                imagekey: rb.staff_imagekey,
                                slots: [],
                                optionalResources: [],
                                optionalIds: new Set()
                            });
                        }
                        const entry = resourceMap.get(rb.staff_id);
                        const start = Date.newFull(rb.time);
                        const end = start.clone().addMinutes(rb.duration);
                        entry.slots.push({ start, end });
                        (rb.optional_resources || []).forEach(or => {
                            if (!entry.optionalIds.has(or.id)) {
                                entry.optionalIds.add(or.id);
                                entry.optionalResources.push(or);
                            }
                        });
                    }
                });
                return Array.from(resourceMap.values()).map(r => {
                    r.optionalResources.sort((a, b) => a.lastname.localeCompare(b.lastname));
                    return r;
                });
            }
            return [];
        },
        staffimagekey() {
            return this.resourceBooking.staff_imagekey;
        },
        bookingTime() {
            return this.resourceBooking.time;
        },
        bookingDuration() {
            return this.booking.duration || this.resourceBooking.duration;
        },
        bookingEndTime() {
            return Date.newFull(this.resourceBooking.time).addMinutes(this.bookingDuration);
        },
        bookingPrice() {
            return this.booking.price != null ? this.booking.price : this.resourceBooking.price;
        },
        contactInfo() { // Priority: Resource with address => extraResource/locationResource => Site Address => Visit address => address
            if (this.resourceBooking.resource_location?.address) {
                return this.resourceBooking.resource_location;
            }

            if (this.resourceBooking.extra_resource_location?.address) {
                return this.resourceBooking.extra_resource_location;
            }

            if (this.resourceBooking.optional_resources?.length >= 1 && this.resourceBooking.optional_resources[0].address) {
                return this.resourceBooking.optional_resources[0];
            }

            if (this.$store.state.settings?.sites?.length > 1) { // MultiSite
                const site = this.$store.state.settings.sites.find(s => s.id == this.resourceBooking.site_id);
                return site;
            }

            const location = this.$store.state.settings.contactinfo;
            if (location.visit_address && location.visit_city && location.visit_zipCode) {
                return { address: location.visit_address, city: location.visit_city, zipCode: location.visit_zipCode };
            }

            return location;
        },
        showPrice() {
            return !!this.$store.state.settings?.modules?.Payment;
        },
        sortedOptionalResources() {
            const optionalResources = this.resourceBooking.optional_resources || [];

            // Sort optional resources on name
            return optionalResources.sort((a, b) => a.lastname.localeCompare(b.lastname));
        },
        extendedInfoEntries() {
            const info = this.resourceBooking.extendedInfo;
            if (!info || Array.isArray(info)) return [];
            return Object.entries(info)
                .filter(([, value]) => {
                    if (value === null || value === undefined) return false;
                    if (Array.isArray(value)) return value.length > 0;
                    if (typeof value === 'string') return value.trim() !== '';
                    return true;
                })
                .map(([question, value]) => {
                    let answer = value;
                    if (Array.isArray(answer)) {
                        answer = answer.join(', ');
                    } else if (typeof answer === 'boolean') {
                        answer = this.$translate(answer ? 'Yes' : 'No');
                    }
                    return { question, answer };
                });
        },
        serviceExtendedInfo() {
            return this.resourceBooking.service_extended_info || [];
        },
        canEditExtendedInfo() {
            if (this.resourceBooking.cancelled) return false;
            const time = this.resourceBooking.time;
            return !!time && Date.newFull(time).getTime() > Date.now();
        },
    },

    methods: {
        startEditingExtendedInfo() {
            const current = this.resourceBooking.extendedInfo && !Array.isArray(this.resourceBooking.extendedInfo)
                ? this.resourceBooking.extendedInfo
                : {};
            this.editFields = this.serviceExtendedInfo.map(q => Object.assign({}, q, {
                title: q.name,
                value: current[q.name] !== undefined ? current[q.name] : ''
            }));
            this.extendedInfoValid = true;
            this.editing = true;
        },
        cancelEditingExtendedInfo() {
            this.editing = false;
            this.editFields = [];
        },
        saveExtendedInfo() {
            if (this.savingExtendedInfo) return;
            if (this.$refs.extendedInfoForm && !this.$refs.extendedInfoForm.validate()) return;

            const payload = Object.fromEntries(this.editFields.map(f => [f.name, f.value]));
            this.savingExtendedInfo = true;
            this.$api.post('/api/memberapi/resourcebooking/extendedinfo/set', payload, {
                id: this.resourceBooking.id
            }).then((response) => {
                this.savingExtendedInfo = false;
                if (!response.ok) {
                    this.$store.commit('showErrorDialog', {
                        title: this.$translate('Error'),
                        text: this.$translate('The booking could not be updated')
                    });
                    return;
                }
                this.$set(this.resourceBooking, 'extendedInfo', payload);
                this.editing = false;
                this.editFields = [];
            }).catch(() => {
                this.savingExtendedInfo = false;
                this.$store.commit('showErrorDialog', {
                    title: this.$translate('Error'),
                    text: this.$translate('The booking could not be updated')
                });
            });
        },
        cancelBooking() {
            this.loading = true;
            this.$api.post('/api/memberapi/resourcebooking/cancel', null, {id: this.resourceBooking.id, sameDateOnly: true}).then((response) => {
                this.loading = false;

                if (!response.ok) {
                    this.$store.commit('showErrorDialog', {title: this.$translate('Cancellation error'), text: this.$translate('The booking could not be cancelled')});
                }

                this.showDialog = !response.ok;
            });
        },
        // FIXME: Move to central place
        formatTime(time) {
            let date = Date.newFull(time);
            var ft = this.$store.state.now30s.clone().clearTime().daysUntil(date);
            if (ft > 6 || ft < 0 || date.getWeekNumber() > new Date().getWeekNumber()) {
                return date.yyyymmdd();
            } else {
                let res = [];
                if (ft == 0) {
                    res = ['Today'];
                } else if (ft == 1) {
                    res = ['Tomorrow', date.getWeekDayString()];
                } else {
                    res = [date.getWeekDayString()];
                }

                res.push(date.hhmm());

                return res.map(this.$translate).join(' ');
            }
        }
    }
}
</script>
